export enum CancelOrderMode {
    Single = 'single',
    Multi = 'multi'
}
